import React from 'react';
import PropTypes from 'prop-types';
import {
  trim,
  words,
  upperCase,
  startCase,
  camelCase,
  isEmpty,
} from 'lodash';

import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const AgentAvatar = ({ fullName, showFullName }) => (
  showFullName ? (
    <Stack direction="row" alignItems="center" gap={1}>
      <Avatar
        sx={{
          width: '2rem',
          height: '2rem',
          display: 'inline-flex',
          fontFamily: 'inherit',
          fontWeight: '800',
          color: 'var(--lightText-1)',
          fontSize: '85%',
        }}
        alt={fullName}
        src="/broken-image.jpg"
      >
        {(!isEmpty(fullName) && words(fullName).length > 1) && upperCase(words(fullName)[0].charAt(0))}
        {(!isEmpty(fullName) && words(fullName).length > 1) && upperCase(words(fullName)[1].charAt(0))}
      </Avatar>
      <span>{startCase(camelCase(trim(fullName)))}</span>
    </Stack>
  ) : (
    <Stack direction="row" alignItems="center" gap={1}>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`tooltip-avatar-${fullName}`} style={{ margin: 0 }}>{fullName}</Tooltip>}
      >
        <Avatar
          sx={{
            width: '2rem',
            height: '2rem',
            display: 'inline-flex',
            fontFamily: 'inherit',
            fontWeight: '800',
            color: 'var(--lightText-1)',
            fontSize: '85%',
          }}
          alt={fullName}
          src="/broken-image.jpg"
        >
          {(!isEmpty(fullName) && words(fullName).length > 1) && upperCase(words(fullName)[0].charAt(0))}
          {(!isEmpty(fullName) && words(fullName).length > 1) && upperCase(words(fullName)[1].charAt(0))}
        </Avatar>
      </OverlayTrigger>
      <span className="d-none d-print-block">{startCase(camelCase(trim(fullName)))}</span>
    </Stack>
  )
);

AgentAvatar.propTypes = {
  fullName: PropTypes.string.isRequired,
  showFullName: PropTypes.bool.isRequired,
};

export default AgentAvatar;
